<template>
    <notification-item
        title="Bod započítán"
        :created="data.created"
        :author="data.payload.userName"
        avatar="/img/myteam/Avatar.png"
        :link="{ name: 'userDetail', params: { id: data.payload.userId } }"
    >
        <p>Získáváte <span class="semibold semibold--textgreen">1&nbsp;bod</span><template v-if="data.payload.placeName"> za sken v místě <span class="semibold semibold--textgreen">{{ data.payload.placeName }}</span></template>.</p>
        <img class="accepted-scan-image" v-if="data.payload.imageUrl" :src="data.payload.imageUrl" />
    </notification-item>
</template>

<script>
    import NotificationMixin from '../NotificationMixin';

    export default {
        name: 'ScanAccepted',
        mixins: [NotificationMixin],
    }
</script>
